import styled from '@emotion/styled';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

export const Wrapper = styled.div`
  position: relative;

  z-index: ${VIEWER_Z_INDEX.root};
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: hidden;
`;
